var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import { updateAppConfig } from './redux/appConfig/appConfig.slice';
import store from './redux/store';
import theme from './theme';
import { ThemeProvider } from 'styled-components';
import { generateUUID } from 'syf-js-utilities';
import { useEffect } from 'react';
import './const/fontAwesomeLibrary';
// eslint-disable-next-line import/extensions
import '@fortawesome/fontawesome-svg-core/styles.css';
import getAccessToken from './helpers/getaccessToken';
import { authLogin } from './redux/globalAuth/globalAuth.slice';
import i18n from './strings/i18n/i18n';
import { updateTransactionData } from './redux/transactionData/transactionData.slice';
import { clearTransactionEligibleState } from './redux/transactionEligible/transactionEligible.slice';
import { clearAllDisputesState } from './redux/allDisputes/allDisputes.slice';
import getFeatureFlags from './redux/featureFlags/getFeatureFlags';
import { updateMfeConfig } from './redux/mfeConfig/mfeConfig.slice';
import SyfDisputes from './SyfDisputes';
import { DisputeFeature } from './typings';
import GlobalAppStyles from './globalStyles';
var SyfDisputesWrapper = function (_a) {
    var disputesMFEConfig = _a.disputesMFEConfig, accountId = _a.accountId, feature = _a.feature, returnToParent = _a.returnToParent, transaction = _a.transaction, selectedDispute = _a.selectedDispute, navigationHandler = _a.navigationHandler;
    var languageInStorage = localStorage.getItem('language');
    useEffect(function () {
        store.dispatch(updateMfeConfig(disputesMFEConfig));
        store.dispatch(getFeatureFlags());
    }, [disputesMFEConfig]);
    useEffect(function () {
        if (transaction) {
            store.dispatch(updateTransactionData(transaction));
        }
        return function () {
            store.dispatch(clearTransactionEligibleState());
        };
    }, [transaction]);
    useEffect(function () {
        return function () {
            store.dispatch(clearAllDisputesState());
        };
    }, []);
    useEffect(function () {
        var config = {
            accountId: accountId,
            operationId: generateUUID(),
            returnToParent: returnToParent,
            feature: feature,
            selectedDispute: selectedDispute,
            navigationHandler: navigationHandler
        };
        if (feature === DisputeFeature.Questionnaire) {
            config = __assign(__assign({}, store.getState().appConfig), { accountId: accountId });
        }
        store.dispatch(updateAppConfig(config));
    }, [
        accountId,
        returnToParent,
        transaction,
        selectedDispute,
        feature,
        navigationHandler
    ]);
    useEffect(function () {
        if (getAccessToken()) {
            store.dispatch(authLogin());
        }
    }, []);
    useEffect(function () {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(function (error) { return error; });
        }
    }, [languageInStorage]);
    return (_jsx(Provider, __assign({ store: store }, { children: _jsxs(ThemeProvider, __assign({ theme: theme.pallete }, { children: [_jsx(GlobalAppStyles, { targetOrigin: disputesMFEConfig.targetOrigin }), _jsx(SyfDisputes, { selectedDispute: selectedDispute, feature: feature, navigationHandler: navigationHandler })] })) })));
};
export * from './typings';
export default SyfDisputesWrapper;
//# sourceMappingURL=index.js.map